import { render, staticRenderFns } from "./onlineClass.vue?vue&type=template&id=06fd425a&scoped=true"
import script from "./onlineClass.vue?vue&type=script&lang=js"
export * from "./onlineClass.vue?vue&type=script&lang=js"
import style0 from "./onlineClass.vue?vue&type=style&index=0&id=06fd425a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fd425a",
  null
  
)

export default component.exports